<ng-container *transloco="let t">
    <footer class="footer-container container-fluid pb-3 pt-3 pt-lg-4">
      <div class="container d-flex flex-column gap-3">

        <div class="row footer-grid">
          <!-- Footer titles -->
          <div class="d-flex justify-content-start w-100 d-lg-block d-none">
            <img src="assets/icons/icons-alt/tracey-alt-logo-compact.svg" alt="Tracey logo" [style.height]="'28px'">
          </div>
          <p class="light fs-12 d-lg-block d-none">{{t('footer.about.title') | uppercase}}</p>
          <p class="light fs-12 d-lg-block d-none">{{t('footer.products') | uppercase }}</p>
          <p class="light fs-12 d-lg-block d-none">{{t('footer.follow.us') | uppercase }}</p>

          <!-- Tracey -->
          <div class="d-flex flex-column gap-3">
            <div class="d-flex justify-content-start d-lg-none">
              <img src="assets/icons/icons-alt/tracey-alt-logo-compact.svg" alt="Tracey logo" [style.height]="'28px'">
            </div>
            <div>
              <a [routerLink]="[CONTACT_ROUTE]">{{t('app.common.headquartersName')}}</a>
            </div>
            <div class="d-flex flex-column gap-2">
              <div class="d-flex align-items-center gap-3">
                <img src="assets/icons/icons-alt/location-alt-light.svg" alt="Location">
                <a>{{environment.headquartersStreet + ', ' +
                environment.headquartersCity + ' (' + t('app.common.headquartersCounty') + ')' }}
                </a>
              </div>
              <div class="d-flex align-items-center gap-3">
                <img src="assets/icons/icons-alt/mail-light.svg" alt="Mail">
                <a href="mailto: {{environment.contactMail}}">
                  {{t("about.us.contact") + ': ' + environment.contactMail}}
                </a>
              </div>
            </div>
          </div>

          <div class="divider-horizontal h-05 bg-grey d-lg-none"></div>

          <!-- About us -->
          <div class="d-flex flex-column gap-3">
            <p class="light fs-14 d-lg-none">{{t('footer.about.title') | uppercase}}</p>
              <div class="d-flex align-items-center justify-content-between">
                <a [routerLink]="[ABOUT_ROUTE]">{{t('footer.about.title')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <a href="mailto:{{environment.contactMail}}?subject={{t('footer.feedback.thanks')}}">
                  {{t('footer.feedback.thanks')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <a href="mailto: {{environment.contactMail}}">{{t('footer.need.help')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
          </div>

          <!-- Products -->
          <div class="d-flex flex-column gap-3">
            <p class="light fs-14 d-lg-none">{{t('footer.products') | uppercase }}</p>
              <div class="d-flex align-items-center justify-content-between">
                <a [routerLink]="[LANDING_ROUTE]">{{t('footer.products.public')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <a (click)="goToPrivate()" class="underline-hover">{{t('footer.products.private')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <a (click)="goToAdmin()" class="underline-hover">{{t('footer.products.admin')}}</a>
                <img src="assets/icons/icons-alt/chevron-right-light.svg" alt="Open">
              </div>
          </div>

          <!-- Follow us -->
          <div class="d-flex flex-column gap-3">
            <p class="light fs-14 d-lg-none">{{t('footer.follow.us') | uppercase }}</p>
            <div class="d-flex w-100 flex-lg-column gap-3">
              <a class="social-media-container" href="https://www.facebook.com/share/1EjJYfGmwy/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                <img src="assets/icons/icons-alt/facebook-dark-bg.svg" alt="Facebook">
                <span>{{t('footer.socials.facebook')}}</span>
              </a>
              <a class="social-media-container" href="https://www.instagram.com/traceysport?igsi=OGg5aGEwdzllYmx1" target="_blank" rel="noopener noreferrer">
                <img src="assets/icons/icons-alt/instagram-dark-bg.svg" alt="Instagrem">
                <span>{{t('footer.socials.instagram')}}</span>
              </a>
            </div>
          </div>
        </div>

        <div class="social-media-container justify-content-between py-3 gap-3 my-2 cursor-pointer"
             (click)="goToAdmin()">
          <div class="d-flex align-items-center justify-content-start gap-3">
            <img src="assets/icons/icons-alt/calendar-dark-bg.svg" alt="Calendar">
            <span class="fs-14-16 fw-300 text-white">
              {{t("footer.admin.for.organisers")}}
            </span>
          </div>

          <img src="assets/icons/icons-alt/circle-arrow-right.svg" alt="Open">
        </div>


        <div class="d-lg-none d-flex align-items-center justify-content-start" (click)="toggleLegal()">
          <p class="light fs-14">{{t('app.common.legal.documents')}}</p>
          <i class="ms-2 fs-12 fas" [class.fa-chevron-down]="!isLegalOpen" [class.fa-chevron-up]="isLegalOpen" [style.color]="'white'"></i>
        </div>

        <div [class.d-none]="!isLegalOpen" class="d-lg-block">
            <div class="">
              <ul class="list-unstyled d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-1">
                <li>
                  <a [routerLink]="[GENERAL_CONDITIONS_ROUTE]">
                    {{ t("policy.general.conditions") }}
                  </a>
                </li>
                <li>
                  <a [routerLink]="[PERSONAL_DATA_PROTECTION]">
                    {{ t("policy.notice.on.personal.data.protection") }}
                  </a>
                </li>
                <li>
                  <a [routerLink]="[INTELLECTUAL_PROPERTY_ROUTE]">
                    {{ t("policy.intellectual.property") }}
                  </a>
                </li>
                <li>
                  <a [routerLink]="[COOKIE_POLICY_ROUTE]">
                    {{ t("policy.cookie") }}
                  </a>
                </li>
                <li>
                  <a [routerLink]="[COMPLAINTS_AND_DISPUTES]">
                   {{ t("policy.complaints.and.disputes") }}
                  </a>
                </li>
              </ul>
            </div>
        </div>

        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-2">

          <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-1">
            <p class="small light pe-2 d-inline opacity-07">
              {{'Copyright © Tracey'}}
              {{
                ' 2025.(' + getClientVersion() + (FooterComponent.backendVersion ? '-' + FooterComponent.backendVersion
                  : '') + ')'
              }}
            </p>
            <div class="d-flex justify-content-between align-items-center gap-2">
              <p class="small light d-inline opacity-07">
                •
              </p>
              <p class="small light d-inline opacity-07">
                by STOTINKA
              </p>
            </div>
          </div>

          <a href="https://www.byteink.hr/" target="_blank" rel="noopener noreferrer">
            <img src="assets/img/svg/byteink_footer.svg" alt="ByteInk">
          </a>

        </div>

      </div>
    </footer>
</ng-container>


